"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("./../../RecordPreviousEducation.module.css"));
function AsherPage(props) {
    var isPdf = false;
    if (window.isPdf) {
        isPdf = true;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.pageSize + " " + styles.pageBreak },
            props.children,
            react_1.default.createElement("div", { className: styles.footerPosition + " " + styles.textCenter },
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null,
                        "Page ",
                        props.page,
                        " of ",
                        props.totalPages)),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, "PREVIOUS EDITIONS OF THIS FORM WILL NOT BE ACCEPTED"))),
            react_1.default.createElement("div", { className: styles.footerPosition + " " + styles.textRight },
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, "CSC-010")),
                react_1.default.createElement("p", null,
                    react_1.default.createElement("b", null, "REV 10/14")))),
        !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone })));
}
exports.AsherPage = AsherPage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXNoZXJQYWdlLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2FzaGVyL1JlY29yZFByZXZpb3VzRWR1Y2F0aW9uL3BhcnRzL0FzaGVyUGFnZS9Bc2hlclBhZ2UuY29tcG9uZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxnREFBeUI7QUFDekIsaUZBQW9FO0FBRXBFLFNBQWdCLFNBQVMsQ0FBQyxLQUFLO0lBQzNCLElBQUksS0FBSyxHQUFHLEtBQUssQ0FBQTtJQUVqQixJQUFJLE1BQU0sQ0FBQyxLQUFLLEVBQUU7UUFDZCxLQUFLLEdBQUcsSUFBSSxDQUFBO0tBQ2Y7SUFFRCxPQUFPLENBQ0gsOEJBQUMsZUFBSyxDQUFDLFFBQVE7UUFDWCx1Q0FBSyxTQUFTLEVBQUssTUFBTSxDQUFDLFFBQVEsU0FBSSxNQUFNLENBQUMsU0FBVztZQUNuRCxLQUFLLENBQUMsUUFBUTtZQUNmLHVDQUFLLFNBQVMsRUFBSyxNQUFNLENBQUMsY0FBYyxTQUFJLE1BQU0sQ0FBQyxVQUFZO2dCQUMzRDtvQkFDSTs7d0JBQ1UsS0FBSyxDQUFDLElBQUk7O3dCQUFNLEtBQUssQ0FBQyxVQUFVLENBQ3RDLENBQ0o7Z0JBQ0o7b0JBQ0ksK0ZBQTBELENBQzFELENBQ0Y7WUFDTix1Q0FBSyxTQUFTLEVBQUssTUFBTSxDQUFDLGNBQWMsU0FBSSxNQUFNLENBQUMsU0FBVztnQkFDMUQ7b0JBQ0ksbURBQWMsQ0FDZDtnQkFDSjtvQkFDSSxxREFBZ0IsQ0FDaEIsQ0FDRixDQUNKO1FBQ0wsQ0FBQyxLQUFLLElBQUksdUNBQUssU0FBUyxFQUFFLGVBQWEsTUFBTSxDQUFDLFdBQWEsR0FBUSxDQUN2RCxDQUNwQixDQUFBO0FBQ0wsQ0FBQztBQWpDRCw4QkFpQ0MifQ==